import React from 'react';
import { motion } from 'framer-motion';
import useT from '../../../i18n';

/**
 * Slik fungerer det — 4 numbered steps in horizontal grid.
 * Numbers in Fraunces light + bone-dark color, editorial magazine feel.
 */
export default function HowItWorks() {
  const t = useT();
  const s = t.landingV2.how;

  return (
    <section
      className="bg-paper-warm py-section border-t border-ink/[0.06]"
      data-testid="landing-how"
    >
      <div className="max-w-editorial mx-auto px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto">
          <p className="font-sans text-xs uppercase tracking-widest text-ink/50">
            {s.eyebrow}
          </p>
          <h2 className="mt-6 font-display font-light text-display-md text-ink">
            {s.title}
          </h2>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {s.steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{
                duration: 0.6,
                ease: [0.22, 1, 0.36, 1],
                delay: i * 0.08,
              }}
              data-testid={`how-step-${i + 1}`}
            >
              <div className="font-display font-light text-display-md text-bone-dark leading-none">
                {String(i + 1).padStart(2, '0')}
              </div>
              <h3 className="mt-6 font-sans text-base font-medium text-ink">
                {step.title}
              </h3>
              <p className="mt-3 font-sans text-sm text-ink/60 leading-relaxed">
                {step.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
